export default "__VITE_ASSET__90840322__"